<div class="dialog-container">
  <div class="dialog-box">
    <p class="dialog-message">
      Please make sure to Save unsaved Assessment.
    </p>
    <p class="dialog-message">
      Are you sure you want to close Assessment details?
    </p>


    <div class="dialog-actions">
      <button class="btn yes" (click)="onSubmit()">Yes</button>
      <br>
      <button class="btn no" (click)="onCancel()">No</button>
    </div>
  </div>
</div>